/* Dependencies */
import styled, { css } from 'styled-components';

/* Icons */
import { ReactComponent as Arrow } from 'images/icons/sortingArrowDown.svg';

export const List = styled.div.attrs(() => ({
  className: 'ClassroomList',
}))`
  width: 100%;
`;

export const ListHeader = styled.div.attrs(() => ({
  className: 'DirectorListHeader',
}))`
  display: grid;
  grid-template-columns: 1.2fr 0.6fr 0.5fr 0.8fr;
  grid-template-rows: 40px;
  align-items: center;

  border-bottom: 1px solid ${({ theme }) => theme.colors.shadeMediumLight};
  color: ${({ theme }) => theme.colors.shadeDark};
  font-size: 14px;
  margin-bottom: 10px;
`;

export const ListName = styled.div.attrs(() => ({
  className: 'DirectorListName',
}))`
  display: flex;
  align-items: center;
`;

export const SortArrow = styled(Arrow).attrs(() => ({
  className: 'ClassroomListUpArrow',
}))`
  height: 10px;
  width: 14px;

  margin-left: 20px;

  &:hover {
    cursor: pointer;
  }
`;

export const ListAssignedClasses = styled.div.attrs(() => ({
  className: 'DirectorListAssignedClasses',
}))`
  display: none;

  ${({ theme }) => theme.breakPoints.desktop} {
    display: block;
    padding-right: 15px;
  }
`;

export const ListRole = styled.div.attrs(() => ({
  className: 'DirectorRole',
}))`
  display: none;

  ${({ theme }) => theme.breakPoints.desktop} {
    display: block;
    padding-left: 5px;
  }
`;
export const ListPermission = styled.div.attrs(() => ({
  className: 'ListPermission',
}))`
  display: none;

  ${({ theme }) => theme.breakPoints.desktop} {
    display: block;
  }
`;

export const ListEmail = styled.div.attrs(() => ({
  className: 'DirectorEmail',
}))`
  display: none;

  ${({ theme }) => theme.breakPoints.desktop} {
    display: block;
  }
`;

export const ListEmpty = styled.div.attrs(() => ({
  className: 'ClassroomListEmptyState',
}))`
  display: flex;
  align-items: center;
  justify-content: center;

  color: ${({ theme }) => theme.colors.shadeMediumDark};
  font-size: 16px;
  margin: 100px auto;
`;

export const StylesImageModalResultsDeleteDirector = css`
  margin: 30px auto;
  width: 70px;
  height: auto;
`;
